<div class="row align-items-center">
  <div class="col-3">
    <h5 class="text-portbase-blue m-0">
      @for (visitStatus of getVisitStatusIcon(summary.visitStatus); track visitStatus) {
        <span class="fa {{visitStatus.icon}} {{visitStatus.color}}" [title]="visitStatus.tooltip"></span>
      }
      {{ summary.vesselName | titlecase }}
    </h5>
    <div class="d-none d-lg-block"><span class="small">{{ summary.crn }}</span></div>
  </div>
  <div class="col-3">
    <h5 class="text-portbase-blue m-0">
      {{ summary.collectorShortName }}
    </h5>
    @if (appContext.isAdmin()) {
      <div class="d-none d-lg-block fst-italic">
        <span class="small">{{ summary.shipOperatorName }}</span>
      </div>
    }
  </div>
  <div class="col-5 small">{{ formatBerth(summary) }}</div>
  <div class="col-1 text-end spread px-0" style="min-width: 5em">
    @if (summary.collections[0]) {
      <span class="fa fas fa-truck-loading text-portbase-green me-1"
            [title]="'Registered collection'"></span>
      <span class="fa fas fa-calendar-check me-1"
            [ngClass]="hasOpenCollections(summary.collections) ? 'text-muted' : 'text-portbase-green'"
            [title]="hasOpenCollections(summary.collections) ? '' :  'Completed collection'"></span>
      <span class="fa fas fa-money-check-alt me-1"
            [ngClass]="hasOpenFinancials(summary.collections) ? 'text-muted' : 'text-portbase-green'"
            [title]="hasOpenFinancials(summary.collections) ? '' : 'Submitted financials'"></span>
    }
    @if (!summary.collections[0]) {
      <span class="fa fas fa-truck-loading text-muted me-1"></span>
      <span class="fa fas fa-calendar-check text-muted me-1"></span>
      <span class="fa fas fa-money-check-alt text-muted me-1"></span>
    }
  </div>
</div>
